import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-federated-redirect-modal',
  templateUrl: 'federated-redirect-modal.component.html',
  styleUrls: ['./federated-redirect-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FederatedRedirectModalComponent implements OnInit {
  public dialog = inject(MatDialog);
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private authenticationService = inject(AuthenticationService);
  private modalRef = inject<MatDialogRef<FederatedRedirectModalComponent>>(MatDialogRef);

  private identityProvider: string;
  private emailAddress: string;

  public ngOnInit(): void {
    if (this.data) {
      if (this.data.identityProvider) {
        this.identityProvider = this.data.identityProvider;
      }
      if (this.data.emailAddress) {
        this.emailAddress = this.data.emailAddress;
      }
    }
  }

  public close(): void {
    this.modalRef.close();
  }

  public federatedRedirect(): void {
    if (this.identityProvider) {
      void this.authenticationService.signInWithCustomProvider(this.identityProvider);
    }
  }
}
